import { useCallback } from 'react';

import { ColumnInterface, ColumnTypes, GenericObject } from '@app/components/common/Table/DefaultTable/types';

import { CheckboxCell } from './CheckboxCell';
import { DateCell } from './DateCell';
import { DefaultCell } from './DefaultCell';
import { LinkNewBrowserTabCell } from './LinkNewBrowserTabCell';
import { LinkSameBrowserTabCell } from './LinkSameBrowserTabCell';
import { PillsCell } from './PillsCell';
import { StatusCell } from './StatusCell';
import { TitleWithImageCell } from './TitleWithImageCell';

interface RowCellProps {
  resource?: string;
  row: GenericObject;
  column: ColumnInterface;
}

export const RowCell = ({ row, column, resource }: RowCellProps) => {
  const getComponent = useCallback(() => {
    switch (column.type) {
      case ColumnTypes.TITLE:
        return TitleWithImageCell;
      case ColumnTypes.PILLS:
        return PillsCell;
      case ColumnTypes.STATUS:
        return StatusCell;
      case ColumnTypes.LINK_NEW_BROWSER_TAB:
        return LinkNewBrowserTabCell;
      case ColumnTypes.LINK_SAME_BROWSER_TAB:
        return LinkSameBrowserTabCell;
      case ColumnTypes.DATE:
        return DateCell;
      case ColumnTypes.CHECKBOX:
        return CheckboxCell;
      case ColumnTypes.CUSTOM:
        return column.customRender;
      default:
        return DefaultCell;
    }
  }, [column]);

  const Component = getComponent();

  return Component ? <Component row={row} column={column} resource={resource} /> : null;
};
